import React from 'react';

const OnboardingStepLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">{title}</h2>
      {subtitle && <p className="text-gray mb-4">{subtitle}</p>}

      <div className="mb-4">
        {children}
      </div>

      {footer && <div className="text-gray mt-4">{footer}</div>}
    </div>
  );
};

export default OnboardingStepLayout;
